import FeaturePanel from "./featurePanel/featurePanel";

export default FeaturePanel;
